import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, VStack, Heading, Button, HStack, Text } from '@chakra-ui/react';
import { useAuthStore } from '@/stores/authStore';
import { useBirthRecordStore } from '@/stores/birthRecordStore';
import { AppLayout } from '@/components/layout/AppLayout';
import { BirthRecordList } from '@/components/birthRecord/BirthRecordList';
import { FiPlus } from 'react-icons/fi';

/**
 * 出産記録一覧ページコンポーネント
 */
const BirthRecordListPage: FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { birthRecords, loading, error, fetchBirthRecords, deleteBirthRecord } =
    useBirthRecordStore();

  // 出産記録一覧を取得
  useEffect(() => {
    if (user) {
      fetchBirthRecords(user.uid);
    }
  }, [user, fetchBirthRecords]);

  /**
   * 編集処理
   */
  const handleEdit = (recordId: string) => {
    navigate(`/birth-records/${recordId}/edit`);
  };

  /**
   * 削除処理
   */
  const handleDelete = async (recordId: string) => {
    if (user) {
      await deleteBirthRecord(recordId, user.uid);
    }
  };

  /**
   * 新規登録ボタンクリック
   */
  const handleCreate = () => {
    navigate('/birth-records/new');
  };

  // 認証ガードはルート側の ProtectedRoute が担うため、ここでは user は必ず存在する。
  if (!user) return null;

  return (
    <AppLayout>
      <Box maxW="6xl" mx="auto">
        <VStack gap={6} align="stretch">
          {/* ヘッダー */}
          <HStack justify="space-between" flexWrap="wrap" gap={4}>
            <Heading size="xl">出産記録一覧</Heading>
            <HStack gap={2}>
              <Button colorPalette="blue" onClick={handleCreate} size="sm">
                <FiPlus size={16} />
                <Text ml={2}>新規登録</Text>
              </Button>
            </HStack>
          </HStack>

          {/* エラー表示 */}
          {error && (
            <Box p={4} bg="red.50" borderRadius="md" borderWidth={1} borderColor="red.200">
              <Text fontSize="sm" color="red.700">
                {error}
              </Text>
            </Box>
          )}

          {/* 出産記録一覧 */}
          <Box bg="white" p={6} borderRadius="lg" shadow="md">
            <BirthRecordList
              birthRecords={birthRecords}
              userId={user.uid}
              loading={loading}
              error={null}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          </Box>
        </VStack>
      </Box>
    </AppLayout>
  );
};

export default BirthRecordListPage;
